import React from 'react'
import { Router } from '@reach/router'
import { HomePage } from '../pages/home'
import { Brands } from '../pages/brands'
import { SettingsPage } from '../pages/settings'

const MainRoutes = () => (
  <Router>
    <HomePage path="/" default />
    <Brands path="trademarks/*" />
    <SettingsPage path="settings/*" />
  </Router>
)

export default MainRoutes
